import { apiClient } from "@/services/apiClient";

export type CertificateRequestIntentDto = {
  slug: string;
  status: string;
  flowKey: string;
  sortOrder: number;
};

export function getCertificateRequestIntents(): Promise<
  CertificateRequestIntentDto[]
> {
  return apiClient
    .get<CertificateRequestIntentDto[]>("/public/certificate-request-intents")
    .then((res) => res.data);
}
